module.exports = __webpack_public_path__ + "static/media/Asset_Management-desktop.687ec605.png";